// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"_1jBlK","page":"_1bNF8","title":"_34yjY","description":"_2WtIH","loginButtonContainer":"_3KPbj"};